import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Inject, SimpleChange, OnChanges, SimpleChanges } from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { GroupingAndOrderingService } from '@ispm/shared/services/grouping-and-ordering.service';
import { Subject, Observable } from 'rxjs';

import { get, isEqual, cloneDeep, values, isEmpty } from 'lodash';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { AsyncLoaderClass } from '@ispm-client/modules/aggregator/class/asyncloader';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { AgregationService } from '@ispm-client/modules/aggregator/services/aggregator.service';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { FlattenService } from '@ispm-client/modules/aggregator/services';
import { IconfigBinding } from '@ispm-client/modules/aggregator/interfaces';



@Component({
  selector: 'unit-value-grouper',
  templateUrl: './unit-value-grouper.component.html',
  styleUrls: ['./unit-value-grouper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


@Widget('UnitValueGrouper')
export class UnitValueGrouperComponent extends AsyncLoaderClass implements OnInit, IWidgetItem {

  constructor(protected groupingAndOrderingService: GroupingAndOrderingService,
              private _changeDetector: ChangeDetectorRef,
              private _agregationService: AgregationService,
              store: Store<IgenomicsState>,
              _flattenService: FlattenService) {
                super(_agregationService, store, _flattenService );
  }
 /* public set widgetFormInstance(v: FormGroup){
    if (this.parentForm) {
      this.destroyer.next();
    }
    this._widgetFormInstance = v;

    // Every time the form is passed to this component, the parent form should be updated with the latest (current) value
    this.parentForm = of(this._widgetFormInstance.getRawValue()).pipe(
      merge(this._widgetFormInstance.valueChanges),
      // The value of valueChanges is ignored because it returns only the changed fields and not the full form object
      takeUntil(this.destroyer.asObservable()),
      map(v=> this._widgetFormInstance.getRawValue())
    );
  };*/


  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this._widgetPayload = _itemConfig.widgetPayload;
    if (this._widgetPayload['formConfig']) {
      this.formConfig = this._widgetPayload['formConfig'];
    }
    else if (this._widgetPayload['formId']) {
      this.formId = this._widgetPayload['formId'];
    }
    else if (!this._widgetPayload['formId'] && !this._widgetPayload['formConfig']) {
      this.formId = `${UnitValueGrouperComponent.GENERATED_FORM_ID_PREFIX}${StringUtils.generateGuid()}`;
      this.formConfig = [];
      this.formConfig = [
        Object.assign(DynamicFormItem.builder('value', 'value', ITEMS_TYPES.NUMBER).setDefault()
          .setOptions([]), this._widgetPayload.items[0]),
        Object.assign(DynamicFormItem.builder('unit', 'unit',  ITEMS_TYPES.DROPDOWN).setDefault()
          .setOptions([]), this._widgetPayload.items[1])
      ];
    }
    if (!isEmpty(this._widgetPayload['configBindings'])) {
      this.configBindings =  this._widgetPayload.configBindings;
    }

  }
  set widgetData(widgetData: any) {
    this._unittype = this._widgetPayload.unittype;
    this._widgetData = widgetData;
    this.data = get(widgetData, this._widgetPayload.pathToField);
    this.interPolateData = { unitform: widgetData};
    this.triggerConfigBindinds();
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }
    private static GENERATED_FORM_ID_PREFIX = 'UNIT_VALUE';

    private _widgetData;
    private _widgetPayload;
    private _unittype;
    public data;
    public widgetFormInstance;
    public formId;
    public interPolateData;
    public message;
    public classname = 'green';
    public parentForm: Observable<any>;
    public configBindings: Array<IconfigBinding>;
  @Input()
  public formConfig;
  public listenToDataChange = true;
  public widgetUpdateValueCallback: (value) => void;
  private destroyer: Subject<any> = new Subject();
  public formItems: any;

  ngOnInit() {
    this.widgetFormInstance.valueChanges.pipe(
      takeUntil(this.destroyer.asObservable()),
      distinctUntilChanged((prev, curr) => {
        return isEqual(prev, curr);
      })).subscribe(d => {
        this.interPolateData = { unitform: d };
        this.triggerConfigBindinds();
      });

  }
  onConfigSetToOptions(options: Array<any>, formKey: string) {

  }
  onConfigSetToConfig(config: object, formKey: string) {

  }

  triggerConfigBindinds() {
    if (!isEmpty(this.configBindings)) {
      this.registerConfigQueries(cloneDeep(this.configBindings), this.formId, this.formConfig[1].configIds,
        'unit', this.interPolateData, true).subscribe(data => {
        this.formConfig[1].options.values = data[0];
        this.registerConfigQueries(cloneDeep(this.configBindings), this.formId, this.formConfig[0].configIds,
          'value', this.interPolateData, true).subscribe(dasta => {
          const minmax = Object.assign({ }, ...dasta)[0];
          this.formConfig[0].min = minmax['value'].min;
          this.formConfig[0].max = minmax['value'].max;
          const currVAlue = get(this._widgetData[this._widgetPayload.pathToField], 'value');
          if (minmax['value'].min === undefined) {
            this.classname = 'grey';
            this.message = 'Please select approriate unit';
            this.formConfig[1].value = { code: '', display: 'Select' };
          } else {
            if ((currVAlue > minmax['value'].min) && (currVAlue < minmax['value'].max)) {
              this.classname = 'green';
            } else {
              this.classname = 'red';
            }
            this.message = 'Value ' + minmax['value'].min + ' > and < ' + minmax['value'].max;
          }
        });
      });

      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }


  }

  onBundleSubscribe(dataAysncloader: object) {

   }

/*set widgetFormInstance( widgetFormInstance: FormGroup) {
  this._widgetFormInstance = widgetFormInstance;

  //this._widgetFormInstance.setValidators([this.updateValidity]);
  this._widgetFormInstance.updateValueAndValidity();
 }*/

  updateItemValue(data, event) {
    if (this._widgetPayload.pathToField) {
      this._widgetData[this._widgetPayload.pathToField] = event.form;
    } else {
      this._widgetData = event.form;
    }

    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this._widgetData]);
    }
  }

  ngOnDestroy(): void {
    this.destroyer.next();
    this.destroyer.complete();
  }

}
